import React from 'react';
import { cn } from '../lib/utils';
import { imageUrl } from '../lib/images';

export default function Logo({ className = "", variant = "default" }) {
  const logos = {
    default: "/_assets/th-skovservice-logo.png",
    white: "/_assets/th-skovservice-logo.png"
  };

  return (
    <img 
      src={imageUrl(logos[variant] || logos.default, 'width=240,quality=90,format=auto')} 
      alt="TH Skovservice - Træfældning, skovservice og naturpleje på Mors og i Thy" 
      className={cn("h-[80px] w-auto transition-transform duration-300 hover:scale-110", className)}
    />
  );
}
